import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Field } from 'redux-form';
import renderSelectField from '../../../../../../shared/components/form/Select';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';


const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class ECO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],
      professional: "",
      addedDiagnostics: [],
      openModal: false,
      loadProfessionals: false,
      loadAddedDiagnostics: false,
      vid: "",
      pp: "",
      ps: "",
      vis: "",
      fe: "",
      rao: "",
      ao: "",
      anillo_oa: "",
      vd: "",
      ai: "",
      a: "",
      e: "",
      tap_se: "",
      ad: "",
      description: "",
      conclusions: "",
      diagnostico: "",
      descripcion_d: "",      
      dataPatient: [],
      age: '',
      date: new Date(),
      birthday: null,
      today: new Date(),
      day: new Date(),
      profile: sessionStorage.getItem('perfil'),
    }
  }

  componentDidMount() {
    this.getData();
    this.setState({ addedDiagnostics: this.props.addedMedicaments });        
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.professional !== null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.professional) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty }, () => {
              this.setState({ professional: this.props.professional, loadProfessionals: false });
              this.props.handlerMedicalProcedures("ECO", "professional", this.props.professional);
            });
          }
        });
      })
        .catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };  

  saveProcedure() {

    const day = new Date();
    const data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      fecha: moment(day).format("YYYY-MM-DD"),
      hora: moment(day).format('LT'),
      eco: {
        profesional: this.props.professional.nombres + " " + this.props.professional.apellido1,
        vid: this.state.vid,
        pp: this.state.pp,
        ps: this.state.ps,
        vis: this.state.vis,
        fe: this.state.fe,
        rao: this.state.rao,
        ao: this.state.ao,
        anillo_oa: this.state.anillo_oa,
        vd: this.state.vd,
        ai: this.state.ai,
        a: this.state.a,
        e: this.state.e,
        tap_se: this.state.tap_se,
        adult: this.state.adult,
        description: this.state.description,
        conclusions: this.state.conclusion,
        diagnostico: this.state.addedDiagnostics,
        descripcion_d: "",
      },
      stress: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        resposo: "",
        ejercicio: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      prueba: {
        professional: "",
        conclusiones: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      ekg: {
        professional: "",
        ritmo: "",
        fc: "",
        ondaP: "",
        pr: "",
        qr_s: "",
        eje_qrs: "",
        styt: "",
        qtc: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      holter: {
        professional: "",
        conclusion: "",
        medicament: "",
        descripcion_d: ""
      },
      map: {
        professional: "",
        conclusion: "",
        diagnostico: "",
        descripcion_d: ""
      },
    }

    console.log(data);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        alert("procedimiento creado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL + '/pages/search-clinic-history',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    console.log(professional);
    this.setState({ professional: professional });
  }

  handlerConclusion = (conclusions) => {
    this.setState({ conclusions: conclusions });
  }

  handlerDescription = (description) => {
    this.setState({ description: description });

  }

  handlerAdult = (adult) => {
    this.setState({ adult: adult });
  }

  handlerFe = (fe) => {
    this.setState({ fe: fe });
  }

  handlerAd = (ad) => {
    this.setState({ ad: ad });
  }

  handlerAi = (ai) => {
    this.setState({ ai: ai });
  }

  handlerVis = (vis) => {
    this.setState({ vis: vis });
  }

  handlerTapse = (tap_se) => {
    this.setState({ tap_se: tap_se });
  }

  handlerVd = (vd) => {
    this.setState({ vd: vd })
  }

  handlerPs = (ps) => {
    this.setState({ ps: ps })
  }

  handlerA = (a) => {
    this.setState({ a: a });
  }

  handlerAo = (ao) => {
    this.setState({ ao: ao });
  }

  handlerPp = (pp) => {
    this.setState({ pp: pp });
  }

  handlerE = (e) => {
    this.setState({ e: e });
  }

  handlerRao = (rao) => {
    this.setState({ rao: rao });
  }

  handlerVid = (vid) => {
    this.setState({ vid: vid });
  }

  render() {

    return (
      <Col>
        <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
          <div className="card__title">
            <h5 className="bold-text">ECO</h5>
          </div>

          <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
            <TextField
              required
              disabled
              id="specilaity-standard-required"
              label="Especialidad"
              type="text"
              value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad }
              onChange={(e) => {
                this.handlerSpeciality(e.target.value);
              }}
            />
            <TextField
              required
              disabled
              id="professional-standard-required"
              label="Profesional"
              type="text"
              value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
              onChange={(e) => {
                this.handlerProfessional(e.target.value);
              }}
            />
          </div>

          <table className="table " style={{ marginTop: 20 }} >
            <tbody>
              <tr>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>VID</span>
                    <div className="form__form-group-field">
                      <Field
                        name="VID-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {
                          this.props.handlerMedicalProcedures("ECO", "vid", e.target.value);
                          this.handlerVid(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>RAO</span>
                    <div className="form__form-group-field">
                      <Field
                        name="RAO-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {
                          this.props.handlerMedicalProcedures("ECO", "rao", e.target.value);
                          this.handlerRao(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>E</span>
                    <div className="form__form-group-field">
                      <Field
                        name="E-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {
                          this.props.handlerMedicalProcedures("ECO", "e", e.target.value);
                          this.handlerE(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>PP</span>
                    <div className="form__form-group-field">
                      <Field
                        name="PP-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "pp", e.target.value);
                          this.handlerPp(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>ANILLO AO</span>
                    <div className="form__form-group-field">
                      <Field
                        name="ANILLO-AO-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "ao", e.target.value);
                          this.handlerAo(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>A</span>
                    <div className="form__form-group-field">
                      <Field
                        name="A-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "a", e.target.value);
                          this.handlerA(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>PS</span>
                    <div className="form__form-group-field">
                      <Field
                        name="PS-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "ps", e.target.value);
                          this.handlerPs(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>VD</span>
                    <div className="form__form-group-field">
                      <Field
                        name="VD-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "vd", e.target.value);
                          this.handlerVd(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>TAPSE</span>
                    <div className="form__form-group-field">
                      <Field
                        name="TAPSE-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "tapse", e.target.value);
                          this.handlerTapse(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>VIS</span>
                    <div className="form__form-group-field">
                      <Field
                        name="VIS-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "vis", e.target.value);
                          this.handlerVis(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>AI</span>
                    <div className="form__form-group-field">
                      <Field
                        name="AI-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "ai", e.target.value);
                          this.handlerAi(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>AD</span>
                    <div className="form__form-group-field">
                      <Field
                        name="AD-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "ad", e.target.value);
                          this.handlerAd(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ margin: 'auto', marginLeft: 10, display: 'flex' }}>
                    <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10, width: 90 }}>FE %</span>
                    <div className="form__form-group-field">
                      <Field
                        name="FE-ECO"
                        component="input"
                        type="text"
                        placeholder=""
                        onChange={(e) => {

                          this.props.handlerMedicalProcedures("ECO", "fe", e.target.value);
                          this.handlerFe(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="Form">
            <div className="form__form-group">
              <span className="form__form-group-label">MAYOR DE EDAD</span>
              <div className="lumber-form__form-group-field">
                <Field
                  className="years-select"
                  name="select-adult-ECO"
                  component={renderSelectField}
                  options={[
                    { value: 'ADULTO', label: 'ADULTO' },
                    { value: 'PEDIATRA', label: 'PEDIATRA' },
                  ]}
                  value={this.state.type}
                  onChange={(e) => {

                    this.props.handlerMedicalProcedures("ECO", "adult", e.value);
                    this.handlerAdult(e.value)
                  }}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Descripción</span>
              <div className="form__form-group-field">

                <textarea
                  name="textarea-description-ECO" rows="10" cols="50"
                  defaultValue={this.props.dataProcedure.description}
                  onChange={(e) => {

                    this.props.handlerMedicalProcedures("ECO", "description", e.target.value);
                    this.handlerDescription(e.target.value);
                  }}>

                </textarea>
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Conclusiones</span>
              <div className="form__form-group-field">

                <textarea
                  name="textarea-conclusions-ECO" rows="10" cols="50"
                  defaultValue={this.props.dataProcedure.conclusions}
                  onChange={(e) => {

                    this.props.handlerMedicalProcedures("ECO", "conclusions", e.target.value);
                    this.handlerConclusion(e.target.value);

                  }}>

                </textarea>
              </div>
            </div>
          </div>
        </div>

        {this.state.profile === "12" || this.state.profile === "4" ?
          (<Button
            style={{ marginTop: 20 }}
            variant="contained"
            color="primary"
            onClick={() => {
              this.saveProcedure();
            }}
          > Guardar Procedimieto
          </Button>) : null
        }      

      </Col>
    )
  }
}

export default ECO;
